export default {
    book: 'Κράτηση {product}',
    age_limit: 'Μόνο για άτομα άνω των {age}',
    change_plan: 'Αλλαγή πλάνου',
    upgrade_product: 'Αναβάθμιση προϊόντος',
    upgrade: 'Αναβάθμιση',
    cancel_upgrade: 'Ακύρωση αναβάθμισης',
    choose_product: 'Επιλέξτε {product}',
    days: '{count} ημέρα | {count} ημέρες',
    login_register: 'Σύνδεση/Εγγραφή',
    current: 'Τρέχον',
    keyless_benefits: {
        label: 'Κατευθείαν στο αυτοκίνητο {0}',
        highlight: 'υπηρεσία ενοικίασης™',
        list: {
            cant_lose_the_key: 'Πλήρης ασφάλιση',
            zero_excess: 'Μηδενική απαλλαγή',
            phone_as_a_key: 'Κινητό ως κλειδί',
            straight_to_car: 'Χωρίς αναμονή',
            no_queues: 'Χωρίς ουρές',
            online_id_check: 'Έλεγχος ταυτότητας online',
            self_checkout: 'Αυτόματο check-out',
        },
    },
};
